import { useState, useEffect, useRef } from 'react';

const useDrivers = (selectedApiKey) => {
  const [drivers, setDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [driversError, setDriversError] = useState('');
  const errorTimeoutRef = useRef(null);

  useEffect(() => {
    const fetchDrivers = async () => {
      if (selectedApiKey) {
        try {
          const response = await fetch(
            `https://fleetbooster.net/getCarrierDriversCopilot?ApiKey=${selectedApiKey}`
          );

          if (response.status >= 400 && response.status < 500) {
            setDrivers([]);
            setFilteredDrivers([]);
            setDriversError('Invalid API Key or no drivers for this carrier are defined');
            if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
            errorTimeoutRef.current = setTimeout(() => setDriversError(''), 5000);
            return;
          }
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          setDrivers(data || []);
          setFilteredDrivers(data || []);
          setDriversError('');
        } catch (err) {
          setDrivers([]);
          setFilteredDrivers([]);
          setDriversError('Error fetching drivers: ' + err.message);
          if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
          errorTimeoutRef.current = setTimeout(() => setDriversError(''), 5000);
        }
      } else {
        setDrivers([]);
        setFilteredDrivers([]);
        setDriversError('');
      }
    };

    fetchDrivers();

    return () => {
      if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
    };
  }, [selectedApiKey]);

  return { drivers, setDrivers, filteredDrivers, setFilteredDrivers, error: driversError };
};

export default useDrivers;